export default "__VITE_ASSET__BZIkWXoM__"